import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"

const initialState = { status: null, loading: false, data: [], error: "", message: '' }

export const dailyStatsAction = createAsyncThunk(
    'daily-stats',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/daily/stats?startDate=${data?.startDate || ""}&endDate=${data?.endDate || ""}&page=${data?.page || 1}&limit=${data?.limit || 25}&app_id=${data?.app_id || ""} `, )
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const dailyStatsSlice = createSlice({
    name:'daily-stats',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(dailyStatsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(dailyStatsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(dailyStatsAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const dailyStatsReducer = dailyStatsSlice.reducer